import { CardSummary } from "../../common/components/card/summary";
import {Button} from "../../common/components/controls/button/button";
import { textChooser } from "../../common/util/textChooser";
import { ProfileSummary } from "../profile/profileSummary";
import { levelExpertise } from "../../common/util/GlobalData";
import { useUser } from "../../common/hooks/User";
import { Avatar } from "../../common/components/avatar";
import styled from "styled-components";
import { useEffect, useState } from "react";
import { getCountries } from "../../common/apis/public.api";
import { ImportantText } from "../../common/components/important_text";

const TopPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 15px 0 40px 0;
  gap: 30px;
`;

const UserInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin: 15px 0;
  gap: 25px;
  padding: 20px 25px;
  background: var(--colorGray2);
  border-radius: 10px;

  & > span{
    zoom: 3;
    border: 1px solid var(--colorNavy);
  }

  .user-info{
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 6px;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 40px;
  gap: 30px;

  button {
    width: 50%;
    max-width: 200px;
  }
`;

interface SummaryInterface {
  handleSubscription: () => void;
  setCurrentStep: (step: string) => void;
  summaryData: any;
  isLoading: boolean;
}

export default function Summary({ handleSubscription, setCurrentStep, summaryData, isLoading }: SummaryInterface) {

  const { name, lastName, imageUrl } = useUser().getDataAll();
  const { refreshUserSession } = useUser();
  const [countries, setCountries] = useState();

  // setting default values in case one or many of the fields are not configured on the company side.
  const { technicalKnowledge = [], technicalKnowledgeIt = [], languages = [] } = summaryData;

  async function getCountriesList() {
    const countriesList = await getCountries();
    setCountries(countriesList);
  }

  useEffect(() => {
    getCountriesList()
  }, []);

  useEffect(() => {
    refreshUserSession();
    window.scrollTo(0, 0)
  }, [])

  const idToString = (id: string) => {
    if (id === '0') {
      return { label: textChooser("txt112"), value: "0" }
    }
    return levelExpertise.find((item) => item.value === id);
  }

  return (
    <div className="page -profile"> 
      <TopPageWrapper>
        <div>
          <h1 className="text sizeXl cleaned">
            {textChooser("txt205")}
          </h1>
          <p className="text sizeSm cleaned" style={{marginTop: 8}}>
            {textChooser("txt203")}
          </p>
        </div>
        <div>
          <ImportantText>
            <p >
              <strong>Llena y verifica toda la información que se solicita en el formulario</strong> para que puedas aplicar correctamente a la oportunidad.
            </p>
          </ImportantText>
        </div>
      </TopPageWrapper>

      <UserInfoWrapper>
        <Avatar url={imageUrl} squared />
        <div className="user-info">
          <label className="text sizeSm">{textChooser("txt22")}</label>
          <span className="text sizeSm styleBold">{name}</span>
          <span/>
          <label className="text sizeSm">{textChooser("txt23")}</label>
          <span className="text sizeSm styleBold">{lastName}</span>
        </div>
      </UserInfoWrapper>

      <ProfileSummary countries={countries} />

      <CardSummary summaryTitle={textChooser('txt122')} isGray>
        <div className="summary-desc">
          {!!technicalKnowledge.length && (
            <div>
              <h3>{textChooser('txt168')}</h3>
              {technicalKnowledge?.map((item: any) =>
                <div className="row">
                  <div className="col-sm-6">{item.name}</div>
                  <div className="col-sm-6">{idToString(item.value)?.label}</div>
                </div>
              )}
            </div>
          )}
          
          {!!technicalKnowledgeIt.length && (
            <div>
              <h3 style={{ marginTop: 24 }}>{textChooser('txt194')}</h3>
              {technicalKnowledgeIt.map((item: any) => (
                <div className="row">
                  <div className="col-sm-6">{item.name}</div>
                  <div className="col-sm-6">{idToString(item.value)?.label}</div>
                </div>
              ))}
            </div>
          )}
          
          {!!languages.length && (
            <div>
              <h3 style={{ marginTop: 24 }}>{textChooser('txt196')}</h3>
              {languages.map((item: any) =>
                <div className="row">
                  <div className="col-sm-6">{item.name}</div>
                  <div className="col-sm-6">{idToString(item.value)?.label}</div>
                </div>
              )}
            </div>
          )}
        </div>
      </CardSummary>
      
      <ButtonWrapper>
        <Button onClick={() => setCurrentStep('skills')} info>
          {textChooser('txt43')}
        </Button>
        <Button onClick={handleSubscription} disabled={isLoading} primary>
          {textChooser('txt144')}
        </Button>
      </ButtonWrapper>
    </div>
  );
}